'use client';

import { AuthProvider } from '../contexts/AuthContext';
import { ReactNode } from 'react';
import PushNotificationPrompt from './PushNotificationPrompt';

interface AuthClientRootProps {
  children: ReactNode;
}

export default function AuthClientRoot({ children }: AuthClientRootProps) {
  return (
    <AuthProvider>
      {children}
      {/* Global: full-screen push opt-in for logged-in users on every page
          (and the "notifications blocked" bar) — see PushNotificationPrompt. */}
      <PushNotificationPrompt />
    </AuthProvider>
  );
}